import React, { useEffect, useState } from "react";
import axios from "axios";

/**
 * Sprint 8a — HostnameRouter
 *
 * Ruft beim App-Boot EINMAL `/api/public/domain/resolve?host=...` auf und merkt sich
 * das Resolve-Resultat im Context. Dadurch kann die App entscheiden, ob sie
 * - die volle Default-App (revenioo.ai / preview / localhost)
 * - das Agency-Portal-Profil (custom_portal_domain)
 * - den Company-Offer-Modus (custom_offer_domain)
 * - oder die UnknownDomainPage rendert.
 *
 * Bewusst minimal: kein Routing-Refactor. Wir liefern nur die Info, App.js entscheidet.
 */

const DEFAULT_RESULT = {
  type: "default",
  host: "",
  agency: null,
  company: null,
  allowed_routes: ["*"],
  loading: false,
  error: false,
};

export const HostnameContext = React.createContext(DEFAULT_RESULT);

export function useHostname() {
  return React.useContext(HostnameContext);
}

export function HostnameProvider({ children }) {
  const [state, setState] = useState({ ...DEFAULT_RESULT, loading: true });

  useEffect(() => {
    let alive = true;
    const host = (typeof window !== "undefined" ? window.location.hostname : "") || "";
    const apiBase = process.env.REACT_APP_BACKEND_URL || "";
    (async () => {
      try {
        const r = await axios.get(`${apiBase}/api/public/domain/resolve`, {
          params: { host },
          timeout: 6000,
        });
        if (!alive) return;
        setState({ ...DEFAULT_RESULT, ...r.data, loading: false });
      } catch (e) {
        if (!alive) return;
        // Bei Fehler defensiv: behandeln wie Default-Host → App funktioniert weiter
        setState({ ...DEFAULT_RESULT, host, loading: false, error: true });
      }
    })();
    return () => { alive = false; };
  }, []);

  return (
    <HostnameContext.Provider value={state}>
      {children}
    </HostnameContext.Provider>
  );
}
